const BASE_URL = process.env.REACT_APP_API_URL || '';
const TOKEN_KEY = 'oca_token';

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

function buildUrl(path, params) {
  let url = `${BASE_URL}/api${path}`;
  if (params) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') query.append(key, value);
    });
    const qs = query.toString();
    if (qs) url += `?${qs}`;
  }
  return url;
}

function parseFilename(contentDisposition) {
  if (!contentDisposition) return null;
  const match = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return match ? match[1] : null;
}

async function getBlob(path, params) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(buildUrl(path, params), { method: 'GET', headers });

  if (res.status === 401) {
    setToken(null);
    if (!window.location.pathname.startsWith('/admin/login')) {
      window.location.href = '/admin/login';
    }
  }

  if (!res.ok) {
    let data = null;
    const text = await res.text();
    if (text) {
      try { data = JSON.parse(text); } catch { data = text; }
    }
    const message = (data && (data.message || data.error)) || `Error ${res.status}`;
    const error = new Error(message);
    error.status = res.status;
    error.errors = data && data.errors;
    error.data = data;
    throw error;
  }

  const blob = await res.blob();
  const filename = parseFilename(res.headers.get('Content-Disposition'));
  return { blob, filename };
}

async function requestForm(method, path, formData) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(buildUrl(path), { method, headers, body: formData });

  if (res.status === 401) {
    setToken(null);
    if (!window.location.pathname.startsWith('/admin/login')) {
      window.location.href = '/admin/login';
    }
  }

  const text = await res.text();
  let data = null;
  if (text) {
    try { data = JSON.parse(text); } catch { data = text; }
  }

  if (!res.ok) {
    const message = (data && (data.message || data.error)) || `Error ${res.status}`;
    const error = new Error(message);
    error.status = res.status;
    error.errors = data && data.errors;
    error.data = data;
    throw error;
  }

  return data;
}

async function request(method, path, { body, params } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  let fetchBody;
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    fetchBody = JSON.stringify(body);
  }

  const res = await fetch(buildUrl(path, params), { method, headers, body: fetchBody });

  if (res.status === 401) {
    setToken(null);
    if (!window.location.pathname.startsWith('/admin/login')) {
      window.location.href = '/admin/login';
    }
  }

  const text = await res.text();
  let data = null;
  if (text) {
    try { data = JSON.parse(text); } catch { data = text; }
  }

  if (!res.ok) {
    const message = (data && (data.message || data.error)) || `Error ${res.status}`;
    const error = new Error(message);
    error.status = res.status;
    error.errors = data && data.errors;
    error.data = data;
    throw error;
  }

  return data;
}

export const apiClient = {
  get: (path, params) => request('GET', path, { params }),
  post: (path, body) => request('POST', path, { body }),
  put: (path, body) => request('PUT', path, { body }),
  patch: (path, body) => request('PATCH', path, { body }),
  delete: (path) => request('DELETE', path),
  postForm: (path, formData) => requestForm('POST', path, formData),
  getBlob,
  getToken,
  setToken,
};
